import {
  ADD_NOTIFICATION,
  ADD_NOTIFICATION_FAILURE,
  ADD_NOTIFICATION_SUCCESS,
  //
  DELETE_NOTIFICATION,
  DELETE_NOTIFICATION_FAILURE,
  DELETE_NOTIFICATION_SUCCESS,
  //
  EDIT_NOTIFICATION,
  EDIT_NOTIFICATION_FAILURE,
  EDIT_NOTIFICATION_SUCCESS,
  //
  FETCH_NOTIFICATION,
  FETCH_NOTIFICATION_FAILURE,
  FETCH_NOTIFICATION_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
} from "./constants";

// List
export const fetchNotification = (payload) => ({
  type: FETCH_NOTIFICATION,
  payload,
});
export const fetchNotificationSuccess = (payload) => ({
  type: FETCH_NOTIFICATION_SUCCESS,
  payload,
});
export const fetchNotificationFailure = (payload) => ({
  type: FETCH_NOTIFICATION_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// ADD
export const addNotification = (payload) => ({
  type: ADD_NOTIFICATION,
  payload,
});
export const addNotificationSuccess = (payload) => ({
  type: ADD_NOTIFICATION_SUCCESS,
  payload,
});
export const addNotificationFailure = (payload) => ({
  type: ADD_NOTIFICATION_FAILURE,
  payload,
});
// EDIT
export const editNotification = (payload) => ({
  type: EDIT_NOTIFICATION,
  payload,
});
export const editNotificationSuccess = (payload) => ({
  type: EDIT_NOTIFICATION_SUCCESS,
  payload,
});
export const editNotificationFailure = (payload) => ({
  type: EDIT_NOTIFICATION_FAILURE,
  payload,
});
// DELETE
export const deleteNotification = (payload) => ({
  type: DELETE_NOTIFICATION,
  payload,
});
export const deleteNotificationSuccess = (payload) => ({
  type: DELETE_NOTIFICATION_SUCCESS,
  payload,
});
export const deleteNotificationFailure = (payload) => ({
  type: DELETE_NOTIFICATION_FAILURE,
  payload,
});
